import { createContext, useContext } from 'react';

const TreeContentContext = createContext({
  isLoading: false,
  items: []
});
function useTreeContent() {
  return useContext(TreeContentContext);
}

export { TreeContentContext, useTreeContent };
//# sourceMappingURL=useTreeContent.js.map
